import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";
import PillarArticle from "../pages/pillar-article/page";
import RootRedirect from "../components/feature/RootRedirect";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <RootRedirect />,
  },
  {
    path: "/:lang",
    element: <Home />,
  },
  {
    path: "/:lang/article/usfans-spreadsheet-guide",
    element: <Article />,
  },
  {
    path: "/:lang/article/:slug",
    element: <PillarArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;